import React, { useState, useEffect } from 'react';
import './DriverPortal.css';
import { authenticateDriver } from '../config/drivers';
import BusinessTracker from '../components/BusinessTracker';

function BusinessPortal() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [driverName, setDriverName] = useState('');

  // Check for saved session
  useEffect(() => {
    const savedName = localStorage.getItem('businessName');
    const savedAuth = localStorage.getItem('businessAuth');
    if (savedName && savedAuth === 'true') {
      setDriverName(savedName);
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    const driver = authenticateDriver(username, password);
    if (driver) {
      setDriverName(driver.name);
      setIsAuthenticated(true);
      setLoginError('');
      localStorage.setItem('businessAuth', 'true');
      localStorage.setItem('businessName', driver.name);
    } else {
      setLoginError('Invalid credentials');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setDriverName('');
    localStorage.removeItem('businessAuth');
    localStorage.removeItem('businessName');
  };

  if (!isAuthenticated) {
    return (
      <div className="driver-portal">
        <div className="driver-login">
          <div className="login-card">
            <a href="/" className="main-link login-main-link">← Back to main site</a>
            <div className="login-logo">
              <span className="logo-icon">📊</span>
              <h1>Business Portal</h1>
              <p>NorCal Mobile Oil Change</p>
            </div>
            <form onSubmit={handleLogin} className="login-form">
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  autoComplete="username"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  autoComplete="current-password"
                  required
                />
              </div>
              {loginError && <p className="login-error">{loginError}</p>}
              <button type="submit" className="login-btn">Login</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return <BusinessTracker driverName={driverName} onBack={handleLogout} />;
}

export default BusinessPortal;
